import { React } from '@/config'
import { Text, View, Button, TextInput } from '@/components'
import { APIClient } from '@/services'
import { useLingui } from '@lingui/react/macro'
import { useCallback, useState } from '@codeleap/hooks'
import { alert, modal } from '@codeleap/modals'

export const ReauthenticationModal = modal<{}, { authenticated: boolean }>({ id: 'reauthentication' }).content(props => {
  const { request } = props

  const [password, setPassword] = useState('')
  const { t } = useLingui()

  const handleContinue = useCallback(async () => {
    try {
      await APIClient.Session.reauthenticate(password)
      request.resolve({ authenticated: true })
    } catch (e) {
      logger.error(e)
      alert.info({
        title: 'Could not authenticate',
        body: 'Please check your credentials.',
      })
    }
  }, [])

  return <>
    <Text
      style={['p1', 'textCenter']}
      text={t`Please re-enter your password to update your email address`}
    />

    <TextInput
      value={password}
      onValueChange={setPassword}
      debugName={'Profile edit password input'}
      leftIcon={{ icon: 'key', debugName: 're-auth password icon' }}
      password
      visibilityToggle
      placeholder={t`Your password`}
      style={['noError']}
    />

    <View style={['row', 'gap:2', 'marginTop:0.5']}>
      <Button
        text={t`Cancel`}
        debugName={'Cancel reauthentication'}
        onPress={() => request.resolve({ authenticated: false })}
        style={['flex', 'outline']}
      />

      <Button
        text={t`Continue`}
        debugName={'Reauthenticate user to update profile'}
        onPress={handleContinue}
        style={['flex']}
        disabled={!password.trim()}
      />
    </View>
  </>
}).props({
  style: ['centered', { body: 'gap:2' }],
  closable: false,
  showClose: false,
  title: 'Authentication'
})